import React from 'react';
import './Footer.css';

function Footer({showExtra}) {
  return (
    <footer>
      <div style={{paddingRight: "1rem"}}>&copy; 2023 Alpha Nexus</div>
      { showExtra &&
        <div>
          <a href="#privacy">Privacy</a> | <a href="#terms">Terms</a>
        </div>
      }
    </footer>
  );
}

export default Footer;
